import React from "react";

interface AccountInfoCardProps {
  title: string;
  accountId: string;
  className?: string;
}

export function AccountInfoCard({
  title = "Your account",
  accountId,
  className = "border border-zinc-200 dark:border-zinc-700 rounded-lg p-4 bg-gray-50 dark:bg-neutral-900",
}: AccountInfoCardProps) {
  return (
    <div className={className}>
      <div className="flex items-center gap-2.5">
        <div className="flex-1">
          <p className="text-sm text-zinc-500 dark:text-zinc-400 mb-0">
            {title}
          </p>
          <p className="text-sm font-semibold text-zinc-900 dark:text-zinc-100">
            {accountId}
          </p>
        </div>
      </div>
    </div>
  );
}
